import * as React from 'react';
import useEventListener from '@use-it/event-listener';
import { ScrollUpSymbol } from 'ui/common/icons/scroll-up-symbol';

import styles from './scroll-to-top.scss';
import { getWindowScroller } from 'app/infrastructure/platform/browser-dom';

const scroller = getWindowScroller();
const scrollUp = () => {
  scroller(0);
};

export const ScrollToTop = React.memo(() => {
  const [visible, setVisible] = React.useState(false);

  useEventListener('scroll', () => {
    const newValue = window.pageYOffset !== 0;
    if(newValue !== visible) {
      setVisible(newValue);
    }
  }, document);

  return <ScrollUpSymbol onClick={scrollUp} className={`${styles.button} ${visible ? styles.visible : ''}`}/>;
});
